<template>
    <div class="memory-game">
        <button @click="selectTile( tile ) + allMatchesFound( tile )" v-for="tile in tiles" :class="{ 'found': tile.found, 'wrong-answer': tile.wrongAnswer, 'active': tile.isActive }"><img class="memory-picture" :src="'/static/img/' + tile.id + '.svg'" /></button>
    </div>
</template>

<style type="text/css"></style>

<script type="text/javascript">
    // import shuffle from '@/vendor/shuffle';
    module.exports = {
        data()
        {
            return {
                tiles: [
                    {
                        id: 'blik',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'RECYCLEN',
                        header: 'Afval verwerken tot herbruikbaar materiaal.',
                        body: 'Wist je dat we in Nederland bijna 94% van alle blikjes recyclen? Daarin zijn wij koploper in Europa. Die blikjes worden omgesmolten en daar maken we bijvoorbeeld jouw nieuwe fiets van!'
                    },
                    {
                        id: 'blik',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'RECYCLEN',
                        header: 'Afval verwerken tot herbruikbaar materiaal.',
                        body: 'Wist je dat we in Nederland bijna 94% van alle blikjes recyclen? Daarin zijn wij koploper in Europa. Die blikjes worden omgesmolten en daar maken we bijvoorbeeld jouw nieuwe fiets van!'
                    },
                    {
                        id: 'mobiel',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'REPARATIE',
                        header: 'Een gebruikt product herstellen zodat het weer opnieuw gebruikt kan worden.',
                        body: 'Wist je dat oude mobieltjes een nieuw leven kunnen krijgen? Hier en daar wat reparaties en updates, en ze zijn weer zo goed als nieuw. Gooi je oude mobieltje dus niet weg, want iemand anders kan er nog jaren plezier van hebben!'
                    },
                    {
                        id: 'mobiel',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'REPARATIE',
                        header: 'Een gebruikt product herstellen zodat het weer opnieuw gebruikt kan worden.',
                        body: 'Wist je dat oude mobieltjes een nieuw leven kunnen krijgen? Hier en daar wat reparaties en updates, en ze zijn weer zo goed als nieuw. Gooi je oude mobieltje dus niet weg, want iemand anders kan er nog jaren plezier van hebben!'
                    },
                    {
                        id: 'bad',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'HERONTWERPEN',
                        header: 'Iets opnieuw ontwerpen of op een andere manier vormgeven.',
                        body: 'Wist je dat je met een klein beetje creativiteit oude producten op een nieuwe manier kan gebruiken? Zaag een oude badkuip in tweeën, leg er een paar mooie kussens in en dan heb je zomaar een superorigineel bankstel!'
                    },
                    {
                        id: 'bad',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'HERONTWERPEN',
                        header: 'Iets opnieuw ontwerpen of op een andere manier vormgeven.',
                        body: 'Wist je dat je met een klein beetje creativiteit oude producten op een nieuwe manier kan gebruiken? Zaag een oude badkuip in tweeën, leg er een paar mooie kussens in en dan heb je zomaar een superorigineel bankstel!'
                    },
                    {
                        id: 'tas',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'VERMIJDEN',
                        header: 'Mensen overhalen om ervoor te kiezen een bepaald product niet te gebruiken.',
                        body: 'Wist je dat er wereldwijd iedere minuut meer dan een miljoen plastic tasjes worden gebruikt? Dat is helemaal nergens voor nodig! Gebruik gewoon een eigen boodschappentas die je steeds opnieuw kunt gebruiken. Dat is veel slimmer!'
                    },
                    {
                        id: 'tas',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'VERMIJDEN',
                        header: 'Mensen overhalen om ervoor te kiezen een bepaald product niet te gebruiken.',
                        body: 'Wist je dat er wereldwijd iedere minuut meer dan een miljoen plastic tasjes worden gebruikt? Dat is helemaal nergens voor nodig! Gebruik gewoon een eigen boodschappentas die je steeds opnieuw kunt gebruiken. Dat is veel slimmer!'
                    },
                    {
                        id: 'pot',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'HERGEBRUIK',
                        header: 'Een product gebruiken voor een ander doeleinde.',
                        body: 'Wist je dat je een blikje kunt hergebruiken als potloodkoker, pennenbakje of make-updoosje? Of zelfs als walkietalkie, voor een kermisspel of als piepklein kruidentuintje? Hoe gaaf is dat?!'
                    },
                    {
                        id: 'pot',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'HERGEBRUIK',
                        header: 'Een product gebruiken voor een ander doeleinde.',
                        body: 'Wist je dat je een blikje kunt hergebruiken als potloodkoker, pennenbakje of make-updoosje? Of zelfs als walkietalkie, voor een kermisspel of als piepklein kruidentuintje? Hoe gaaf is dat?!'
                    },
                    {
                        id: 'fles',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'UPCYCLEN',
                        header: 'Het materiaal van een oud ontwerp omtoveren tot een duurzamer product met een nieuwe functie.',
                        body: 'Wist je dat je met het materiaal van 18 oude plastic flessen een nieuwe rugzak kunt maken? Dat is niet alleen goed voor het milieu maar ook heel handig voor jou, want die rugzak is groot genoeg om al je boeken mee naar school te nemen.'
                    },
                    {
                        id: 'fles',
                        found: false,
                        wrongAnswer: false,
                        isActive: false,
                        title: 'UPCYCLEN',
                        header: 'Het materiaal van een oud ontwerp omtoveren tot een duurzamer product met een nieuwe functie.',
                        body: 'Wist je dat je met het materiaal van 18 oude plastic flessen een nieuwe rugzak kunt maken? Dat is niet alleen goed voor het milieu maar ook heel handig voor jou, want die rugzak is groot genoeg om al je boeken mee naar school te nemen.'
                    }
                ],
                currentTile: null
            };
        },

        computed: {
            gameCopy()
            {
                return this.$store.getters[ 'getCopy' ]( 'game' );
            }
        },

        mounted()
        {
            for( let i = 0; i < this.tiles.length; i++ )
            {
                this.tiles[i].title = this.gameCopy[ this.tiles[i].id ].header;
                this.tiles[i].header = this.gameCopy[ this.tiles[i].id ].subHeader;
                this.tiles[i].body = this.gameCopy[ this.tiles[i].id ].body;
            }

            this.shuffleTiles();
            this.preventInteraction = false;
        },
        methods: {
            shuffleTiles()
            {
                this.tiles = shuffle( this.tiles );
            },
            selectTile( tile )
            {
                if( this.preventInteraction === true )
                {
                    return;
                }
                // console.log( tile );
                if( !this.currentTile )
                {
                    this.currentTile = tile;
                    tile.isActive = true;
                }
                else
                {
                    if( this.currentTile.id === tile.id )
                    {
                        // console.log( 'match' );
                        this.currentTile.found = true;
                        tile.found = true;
                        tile.wrongAnswer = false;
                        tile.isActive = false;

                        for( let i = 0; i < this.tiles.length; i++ )
                        {
                            this.tiles[i].isActive = false;
                        }

                        this.$emit( 'match', tile );
                    }
                    else if( this.currentTile.id !== tile.id )
                    {
                        // console.log( 'wrong' );

                        tile.wrongAnswer = true;
                        this.currentTile.wrongAnswer = true;
                        tile.isActive = true;
                        this.preventInteraction = true;

                        setTimeout( () =>
                        {
                            for( let i in this.tiles )
                            {
                                this.tiles[ i ].isActive = false;
                            }
                        }, 300 );

                        setTimeout( () =>
                        {
                            for( let i in this.tiles )
                            {
                                this.tiles[ i ].wrongAnswer = false;
                            }
                            this.preventInteraction = false;
                        }, 300 );
                    }
                    this.currentTile = null;
                }
            },
            allMatchesFound()
            {
                if( this.tiles.every( element => element.found === true ) )
                {
                    // console.log( 'finish' );
                    this.$emit( 'finish' );
                }
                else
                {
                    // console.log( 'not finished' );
                }
            }
        }
    };

    function shuffle( array )
    {
        return array.sort( e =>
        {
            return Math.random() < 0.5 ? 1 : -1;
        });
    }

</script>
